import { observer } from "mobx-react";
import React, { Fragment, useEffect } from "react";
import store from "../store";

const Render = ({ children, mounted }) => {
  const {
    util: { globalMountConfig },
  } = store;

  useEffect(() => {
    store.setGlobalMountConfig({ isMounted: mounted });
  }, [mounted]);

  return mounted && globalMountConfig?.isMounted ? (
    children
  ) : (
    <Fragment />
  );
};

export default observer(Render);
